import React from 'react';
import { connect } from 'react-redux';

class Loading extends React.Component {

  render() {
    return (
      <div className="loading-new" >
        <div className="spinner" style={{backgroundColor: this.props.color || "#DE171F"}} />
      </div>
      // <div className="loading2">
      //   <div className="spinner2">
      //     <div className="bar bar1"/>
      //     <div className="bar bar2"/>
      //     <div className="bar bar3"/>
      //     <div className="bar bar4"/>
      //     <div className="bar bar5"/>
      //     <div className="bar bar6"/>
      //     <div className="bar bar7"/>
      //     <div className="bar bar8"/>
      //     <div className="bar bar9"/>
      //     <div className="bar bar10"/>
      //     <div className="bar bar11"/>
      //     <div className="bar bar12"/>
      //   </div>
      // </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    color: state.rr360.theme.primaryColor
  };
}

export default connect(mapStateToProps, undefined)(Loading);



// WEBPACK FOOTER //
// ./src/components/Loading.js